'use client';

import { X } from 'lucide-react';

interface FullShareViewHeaderProps {
  title: string;
  subtitle: string;
  closeLabel: string;
  onClose: () => void;
}

export function FullShareViewHeader({
  title,
  subtitle,
  closeLabel,
  onClose,
}: FullShareViewHeaderProps) {
  return (
    <div className="shrink-0 py-6 pl-6 pr-5">
      <div className="flex items-start gap-1">
        <div className="min-w-0 flex-1">
          <h2 className="text-[16px] leading-6 font-bold tracking-[-0.5px] text-[#151414]">
            {title}
          </h2>
          <p className="mt-1 text-sm leading-5 text-[#383838]">{subtitle}</p>
        </div>
        <button
          type="button"
          data-hook="share-close"
          onClick={onClose}
          aria-label={closeLabel}
          className="flex size-6 shrink-0 cursor-pointer items-center justify-center rounded-full bg-[#f0efef] text-[#151414] hover:opacity-80"
        >
          <X size={12} />
        </button>
      </div>
    </div>
  );
}
